import { useParams } from "react-router-dom";
import AuditOverview from "./audit/AuditOverview";
import MocOverview from "./moc/MocOverview";
import NonConformanceOverview from "./non-conformance/NonConformanceOverview";
import OfiOverview from "./ofi/OfiOverview";
import LessonLearnedOverview from "../lesson-learned/LessonLearnedOverview";
import IncidentReportOverview from "./incident-report/IncidentReportOverview";
import { reportTypeFromPath } from "../../utils/reporting/reportRoute";

function ReportOverview() {
	const { reportId } = useParams();

	const reportType = reportTypeFromPath(location.pathname);

	const renderContent = () => {
		if (!reportId) return null;
		switch (reportType) {
			case "lesson_learned": {
				return <LessonLearnedOverview reportId={reportId} />;
			}
			case "incident_report": {
				return <IncidentReportOverview reportId={reportId} />;
			}
			case "audit": {
				return <AuditOverview reportId={reportId} />;
			}
			case "moc": {
				return <MocOverview reportId={reportId} />;
			}
			case "ofi": {
				return <OfiOverview reportId={reportId} />;
			}
			case "non_conformance": {
				return <NonConformanceOverview reportId={reportId} />;
			}
		}
	};

	return (
		<div
			className="generic-container overflow-auto transition-all duration-500 ease-in-out"
			style={{ gap: "20px", overflow: "auto" }}
		>
			{renderContent()}
		</div>
	);
}

export default ReportOverview;
